import { useTranslation } from "react-i18next";
import { useLocalization } from "@/hooks/useLocalization";

const MAIN_STORE = "https://kaspreadsheet.com";

export default function ShoppingCompanion() {
  const { t } = useTranslation();
  const { lang } = useLocalization();

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-8 md:grid-cols-2 md:gap-12">
          {/* Left: Image */}
          <div className="relative overflow-hidden rounded-2xl md:rounded-3xl">
            <img
              src="https://readdy.ai/api/search-image?query=Luxury%20streetwear%20fashion%20flat%20lay%20overhead%20view%20of%20a%20cream%20colored%20hoodie%20jacket%20next%20to%20white%20sneakers%20on%20a%20warm%20beige%20linen%20background%20soft%20natural%20light%20editorial%20product%20photography%20minimal%20aesthetic%20warm%20earth%20tones%20no%20text%20high%20quality%20detail&width=800&height=700&seq=companion-img-01&orientation=squarish"
              alt="AllChinaBuy shopping companion"
              className="h-[400px] w-full object-cover md:h-[500px]"
            />
          </div>

          {/* Right: Content */}
          <div className="flex flex-col">
            <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              {t("companion.badge")}
            </span>

            <h2 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
              {t("companion.title")}
            </h2>

            <div className="mt-4 space-y-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              <p>{t("companion.p1")}</p>
              <p>{t("companion.p2")}</p>
              <p>{t("companion.p3")}</p>
            </div>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href={MAIN_STORE}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-foreground-950 px-6 py-3 text-sm font-semibold text-white transition-all hover:bg-foreground-800 whitespace-nowrap cursor-pointer"
              >
                {t("companion.cta.primary")}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
              <a
                href={`/${lang}/articles/allchinabuy-spreadsheet-guide`}
                className="inline-flex items-center justify-center gap-2 rounded-full border border-foreground-200 px-6 py-3 text-sm font-semibold text-foreground-800 transition-all hover:bg-background-100 whitespace-nowrap cursor-pointer"
              >
                {t("companion.cta.secondary")}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}